/**
 * 母亲节产品墙专用：与主题 `component-add-cart-button.js` 逻辑对齐，
 * 优先使用 theme.liquid 中 `script[data-cart-routes]` 的 cartUrl / cartAddUrl（与多市场路径一致），
 * 再回退 `window.routes` / `routes`，避免 `cart_url` 为 `/` 或缺失时出现 `/?section_id=cart-drawer` 404。
 * 自定义元素名：`momday-add-cart-button`
 */
if (!customElements.get("momday-add-cart-button")) {
  function momdayReadCartRoutesJson() {
    try {
      var el = document.querySelector(
        'script[type="application/json"][data-cart-routes]'
      );
      if (!el || !el.textContent) return null;
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function momdayNormalizeCartRoot(url) {
    if (url == null) return "/cart";
    var s = String(url).trim();
    if (!s || s === "/") return "/cart";
    if (s.length > 1 && s.endsWith("/")) return s.slice(0, -1);
    return s;
  }

  function momdayResolveCartRoot() {
    var json = momdayReadCartRoutesJson();
    var list = [];
    if (json && json.cartUrl) list.push(json.cartUrl);
    if (typeof window !== "undefined" && window.routes && window.routes.cart_url) {
      list.push(window.routes.cart_url);
    }
    if (typeof routes !== "undefined" && routes && routes.cart_url) {
      list.push(routes.cart_url);
    }
    for (var i = 0; i < list.length; i++) {
      var n = momdayNormalizeCartRoot(list[i]);
      if (n && n !== "/") return n;
    }
    return "/cart";
  }

  function momdayResolveAddJsonUrl(cartRootNorm) {
    var json = momdayReadCartRoutesJson();
    if (json && json.cartAddUrl) {
      var add = String(json.cartAddUrl).trim();
      if (add) {
        if (add.endsWith(".json")) return add;
        return add.replace(/\/*$/, "") + ".json";
      }
    }
    return (cartRootNorm || "/cart") + "/add.json";
  }

  class MomdayAddCartButton extends HTMLElement {
    _marks = {
      loading: "loading",
    };

    get _variantId() {
      return this.getAttribute("data-variant-id");
    }
    get _quantity() {
      var q = this.getAttribute("data-quantity");
      if (q == null || String(q).trim() === "") return "1";
      return q;
    }

    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._processing = false;
      this._checkout_headers = null;
    }

    _ensureCheckoutHeaders() {
      if (this._checkout_headers) return;
      var script = document.querySelector("script[id='shopify-features']");
      if (!script || !script.innerHTML) {
        throw new Error("momday-add-cart-button: missing #shopify-features");
      }
      var feat = JSON.parse(script.innerHTML);
      this._checkout_headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: "Basic " + btoa(feat.accessToken),
      };
    }

    connectedCallback() {
      try {
        this._ensureCheckoutHeaders();
      } catch (e) {
        console.error(e);
        return;
      }

      this.setAttribute("aria-label", "Add to Cart");
      this.setAttribute("role", "button");
      this.setAttribute("tabindex", "0");

      this.updateQuantity();
      this.elements = {
        loadingSpinner: this.querySelector(".loading__spinner"),
      };
      this.addEventListener("click", this._onClick);
      this.addEventListener("keydown", (e) => {
        if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") {
          return;
        }
        this._onClick();
      });
    }

    disconnectedCallback() {
      this.removeEventListener("click", this._onClick);
    }

    _onClick() {
      if (this._processing) return;
      this._processing = true;
      this.startLoading();
      Promise.resolve(this.addToCart())
        .catch((err) => console.error(err))
        .finally(() => {
          this.finishLoading();
          this._processing = false;
        });
    }

    updateQuantity() {
      /* 母亲节产品墙：卡片上的 data-quantity 已是「主品,配件」逗号串，勿与全站 PDP 数量框同步，否则会冲掉配件数量或产生 NaN */
      if (this.closest("[data-momday-ps-card]")) {
        return;
      }

      var mainQtyElement = document.querySelector(
        ".product-form__main_quantity"
      );

      if (mainQtyElement) {
        var quantityInput = mainQtyElement.querySelector(
          'quantity-input input[name="quantity"]'
        );

        if (quantityInput) {
          if (this._momdayMainQtyBound) return;
          this._momdayMainQtyBound = true;
          var self = this;
          var updateDataQuantity = function () {
            var inputValue = quantityInput.value;
            var raw = self.getAttribute("data-quantity") || "1";
            var quantityArray = raw.split(",");
            quantityArray[0] = inputValue;
            self.setAttribute("data-quantity", quantityArray.join(","));
          };

          quantityInput.addEventListener("change", updateDataQuantity);
          updateDataQuantity();
        }
      }
    }

    onCartUpdate() {
      var cartRoot = momdayResolveCartRoot();

      fetch(cartRoot + "?section_id=cart-drawer")
        .then(function (response) {
          return response.text();
        })
        .then(function (responseText) {
          var html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          var targetElement = document.querySelector("cart-drawer");
          var sourceElement = html.querySelector("cart-drawer");
          if (!targetElement || !sourceElement) return;
          targetElement.innerHTML = sourceElement.innerHTML;
          targetElement.classList.add("active");
          targetElement.classList.remove("is-empty");
          document.querySelector("body").classList.add("overflow-hidden");
        })
        .catch(function (e) {
          console.error(e);
        });

      fetch(cartRoot + ".js")
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(function (cartData) {
          var cartItemCount = cartData.item_count;
          var iconWrap = document.querySelector("#cart-icon-bubble");
          if (!iconWrap) return;
          var cartCountBubble = iconWrap.querySelector(".cart-count-bubble");
          if (!cartCountBubble) {
            cartCountBubble = document.createElement("div");
            cartCountBubble.className = "cart-count-bubble";
            cartCountBubble.innerHTML =
              "<span aria-hidden=\"true\">" +
              cartItemCount +
              "</span><span class=\"visually-hidden\">" +
              cartItemCount +
              " item</span>";
            iconWrap.appendChild(cartCountBubble);
          } else {
            var aria = cartCountBubble.querySelector(
              "span[aria-hidden='true']"
            );
            var vh = cartCountBubble.querySelector(".visually-hidden");
            if (aria) aria.textContent = cartItemCount;
            if (vh) vh.textContent = cartItemCount + " item";
          }
        })
        .catch(function (error) {
          console.error(
            "There has been a problem with your fetch operation:",
            error
          );
        });
    }

    async addToCart() {
      try {
        this._ensureCheckoutHeaders();
      } catch (e) {
        console.error(e);
        return;
      }

      /* 读 data-variant-id（confirm 时已由 momday_s-product-showcase.js 预写好「主品,配件」） */
      var vid = String(this._variantId || "").trim();
      console.log("[momday-atc] addToCart start. data-variant-id='" + vid + "' data-quantity='" + this._quantity + "'");

      /* 卡片内兜底：仅当 data-variant-id 为空或只有主品（1个ID）时，才从卡片属性补全配件。
         若 confirm 已正确写入多个 ID，直接跳过此 fallback，避免重复追加。 */
      var card = this.closest("[data-momday-ps-card]");
      if (card) {
        var mainVidOnCard = String(card.getAttribute("data-main-variant-id") || "").trim();
        if (!vid && mainVidOnCard) vid = mainVidOnCard;

        var existingIds = vid ? vid.split(",").map(function(s){return s.trim();}).filter(Boolean) : [];
        var alreadyHasBundle = existingIds.length > 1;  /* confirm 已写好多 ID，无需 fallback */

        if (!alreadyHasBundle) {
          var bVid = String(card.getAttribute("data-selected-bundle-variant") || "").trim();
          /* data-selected-bundle-qty 现在是逗号列表，只取第一个作兜底数量 */
          var bQtyRaw = String(card.getAttribute("data-selected-bundle-qty") || "0");
          var bQty = parseInt(bQtyRaw.split(",")[0], 10);
          if (isNaN(bQty) || bQty < 0) bQty = 0;
          console.log("[momday-atc] card found (fallback mode). mainVidOnCard=" + mainVidOnCard + " bVid=" + bVid + " bQty=" + bQty);

          /* bVid 可能是逗号列表（多配件），逐一追加 */
          if (bVid && bQty > 0) {
            var bVids = bVid.split(",").map(function(s){return s.trim();}).filter(Boolean);
            var bQtys = bQtyRaw.split(",").map(function(s){return parseInt(s.trim(),10)||1;});
            var newIds = [vid || mainVidOnCard];
            var newQs  = [String(this._quantity || "1").split(",")[0] || "1"];
            bVids.forEach(function(bv, i) {
              if (bv && !existingIds.some(function(e){return e===bv;})) {
                newIds.push(bv);
                newQs.push(String(bQtys[i] || 1));
              }
            });
            if (newIds.length > 1) {
              console.log("[momday-atc] fallback: built vid=" + newIds.join(",") + " qty=" + newQs.join(","));
              vid = newIds.join(",");
              this.setAttribute("data-quantity", newQs.join(","));
            }
          }
        } else {
          console.log("[momday-atc] card found. confirm already wrote " + existingIds.length + " IDs, skip fallback.");
        }
      }

      console.log("[momday-atc] final vid='" + vid + "' quantity='" + this._quantity + "'");
      if (!vid) {
        console.warn("[momday-atc] missing data-variant-id, abort");
        return;
      }

      this.updateQuantity();
      var variantIds = vid.split(",");
      var quantities = String(this._quantity || "1").split(",");
      while (quantities.length < variantIds.length) quantities.push("1");

      var items = variantIds.map(function (id, index) {
        return {
          form_type: "product",
          utf8: "✓",
          id: parseInt(String(id).trim(), 10),
          quantity: parseInt(String(quantities[index] || "1").trim(), 10) || 1,
        };
      });

      items = items.filter(function (it) {
        return it.id && !isNaN(it.id) && it.quantity > 0;
      });
      console.log("[momday-atc] items to POST:", JSON.stringify(items));
      if (!items.length) {
        console.warn("[momday-atc] no valid items, abort");
        return;
      }

      var data = JSON.stringify({ items: items });
      var cartRootNorm = momdayResolveCartRoot();
      var addUrl = momdayResolveAddJsonUrl(cartRootNorm);

      return fetch(addUrl, {
        method: "POST",
        headers: this._checkout_headers,
        body: data,
      })
        .then(async (response) => {
          if (response.ok) {
            if (window.cartGiftSettings) {
              var cartRes = await fetch(cartRootNorm + ".js");
              var cart = await cartRes.json();
              if (window.updateStepCartGift) {
                await window.updateStepCartGift(cart);
              }
            }
            return response.json();
          } else {
            var msg = "";
            try {
              msg = await response.text();
            } catch (x) {}
            if (response.status === 422) {
              alert("Inventory shortage!");
            } else {
              console.error(
                "momday-add-cart POST failed",
                response.status,
                msg
              );
            }
            throw new Error("请求失败");
          }
        })
        .then((response) => {
          var drawerBtn = document.querySelector(
            ".js-drawer-open-button-right"
          );
          if (drawerBtn) drawerBtn.click();
          return this.updateCart(response);
        })
        .catch((err) => {
          console.error(err);
        });
    }

    async updateCart() {
      this.onCartUpdate();
    }

    startLoading() {
      this.setAttribute("aria-disabled", true);
      this.classList.add(this._marks.loading);
      this.elements.loadingSpinner?.classList.remove("hidden");
    }

    finishLoading() {
      this.removeAttribute("aria-disabled");
      this.classList.remove(this._marks.loading);
      this.elements.loadingSpinner?.classList.add("hidden");
    }
  }

  customElements.define("momday-add-cart-button", MomdayAddCartButton);
}
